import { REQUESTED_LEAD, RECEIVED_LEAD, REQUEST_LEAD_FAILED } from '../actions/ViewLead';
import { CLOSE_MODAL } from '../actions/CloseModal';
import { LEAD_PLACES_REDUCED } from '../actions/LeadPlacesReduced';
import { LEAD_PLACES_EXHAUSTED } from '../actions/LeadPlacesExhausted';

const initialState = {
  state: 'off',
  type: '',
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUESTED_LEAD:
      return {
        state: 'loading',
        type: '',
        data: {},
      };
    case RECEIVED_LEAD: {
      const type = action.data.type ? action.data.type : 'accepted';
      return {
        state: 'received',
        type: `${type}-lead-view`,
        data: action.data,
        path: action.path,
      };
    }
    case REQUEST_LEAD_FAILED:
      return initialState;
    case LEAD_PLACES_REDUCED:
      // If the lead with places reduced is the one in the modal update it.
      if (state.type === 'opportunity-lead-view' &&
          action.lead.id === state.data.id
      ) {
        return Object.assign({}, state, {
          data: Object.assign({}, state.data, {
            places: action.lead.places,
          }),
        });
      }

      return state;
    case LEAD_PLACES_EXHAUSTED:
      // If the lead with places exhausted is the one in the modal update it.
      if (state.type === 'opportunity-lead-view' &&
          action.lead.id === state.data.id
      ) {
        return Object.assign({}, state, {
          data: Object.assign({}, state.data, {
            places: action.lead.places,
          }),
        });
      }

      return state;
    case CLOSE_MODAL:
      return initialState;
    default:
      return state;
  }
};
